import { withChartLayout } from 'components/common';
import SkinCare from 'components/features/chart/basic-nursing-care/skin-care/SkinCare';

const SkinCarePage = withChartLayout('Skin Care')(SkinCare);
export default SkinCarePage;
